import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router'; /** *added by chaitu */
import { CustomDomainService } from '../../services/custom-domain.service';
import { AnalyticsService } from '../../services/analytics.service';
import { LanguageChooserComponent } from '../../../shared/components/language-chooser/language-chooser.component';
import { CopyrightComponent } from './copyright/copyright.component';
import { SupportComponent } from './support/support.component';
import { FeaturesComponent } from './features/features.component';
import { ProductsComponent } from './products/products.component';
import { FundraiserForComponent } from './fundraiser-for/fundraiser-for.component';
import { LogoAppLinksComponent } from './logo-app-links/logo-app-links.component';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { FlexModule } from '@angular/flex-layout/flex';
import { NgIf } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: true,
    imports: [NgIf, FlexModule, ExtendedModule, LogoAppLinksComponent, FundraiserForComponent, ProductsComponent, FeaturesComponent, SupportComponent, CopyrightComponent, LanguageChooserComponent, MatIconModule, MatButtonModule]
})
/** *Footer Component */
export class FooterComponent implements OnInit {
	hideFooter: boolean = false;

	constructor(
		private _router: Router,
		public customDomainService: CustomDomainService,
		private analyticsService: AnalyticsService
	) {}

	ngOnInit(): void {
		// Subscribe to router events to determine when to hide the footer
		this._router.events.subscribe((e) => {
			if (e instanceof NavigationEnd) {
				// Check if the URL matches any of the specified paths
				if (
					e.url.includes('/dashboard') ||
					e.url.includes('/account') ||
					e.url.includes('/profile') ||
					e.url.includes('/donate') ||
					e.url.includes('/connect') ||
					e.url.includes('/balance') ||
					e.url.includes('/my-fundraisers') ||
					e.url.includes('/custom-branding') ||
					e.url.includes('/create')
				) {
					this.hideFooter = true;
				} else {
					// Check if the current domain is a custom domain
					this.customDomainService.getIsCustomDomain().subscribe(
						(res: any) => {
							this.hideFooter = res ? true : false;
						},
						(error) => {
							// Handle error case
							console.error('Error fetching custom domain status:', error);
							this.hideFooter = false;
						}
					);
				}
			}
		});
	}

	// Method to open cookie settings
	openCookieSettings() {
		this.analyticsService.openCookieSettings();
	}
}
